import { Fold, Lens, Traversal } from "@discovery/prelude/lib/control/lens";
import * as Optics from "@discovery/sonic-api-ng-optics";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import * as M from "@discovery/prelude/lib/data/maybe";
export const _placeholderImage = Fold.compose(Optics._Col2Items, Fold.liftM((image) => ({
    image,
}), Fold.compose(Optics._ColItem2Image, Traversal._filteredOn(Res._Response(), (image) => image.attributes.kind === "default"), Res._Response(), Lens.prop("attributes"))));
export const Links = Fold.compose(Optics._Col2Items, Optics._ColItem2Collection, Res._Response(), Lens.path("attributes", "title"));
export const ShareAttributes = Fold.compose(Optics._Col2Items, Optics._ColItem2Collection, Optics._Col2Items, Optics._ColItem2Link, Fold.liftM((attributes, image) => ({
    titleM: attributes.title,
    descriptionM: attributes.description,
    url: attributes.href,
    image: M.of(image),
}), Optics._Link2Attributes, Fold.compose(Optics._Link2Images, Traversal._filteredOn(Res._Response(), (image) => image.attributes.kind === "default"), Res._Response(), Lens.prop("attributes"), Lens.prop("src"))));

